import {Injectable} from "@angular/core";
import {NotificationConstants} from "./notification.constants";

@Injectable({
    providedIn: "root",
})
export class NotificationService {
    successMessageShown;
    errorMessageShown;
    errorMessage: { message: string; details?: string };

    constructor() {
    }

    public notifySuccess(): void {
        this.showSuccessMessage();
        setTimeout(() => {
            this.hideSuccessMessage();
        }, 5000);
    }

    public notifyError(message: string = NotificationConstants.default_message, details = ""): void {
        this.showErrorMessage(message, details);
        setTimeout(() => {
            this.hideErrorMessage();
        }, 5000);
    }

    public showSuccessMessage(): void {
        this.clearMessages();
        this.successMessageShown = true;
    }

    public showErrorMessage(message = "", details = ""): void {
        this.clearMessages();
        this.errorMessageShown = true;
        this.errorMessage = {message, details};
    }

    public hideErrorMessage(): void {
        this.errorMessageShown = false;
        this.errorMessage = null;
    }

    public hideSuccessMessage(): void {
        this.successMessageShown = false;
    }

    public clearMessages(): void {
        this.hideSuccessMessage();
        this.hideErrorMessage();
    }
}
